import { apiAction } from '../../shared/store/apiAction';

import * as api from './api';
import { fetchFilingStatesTypes } from './types';

export const fetchFilingStates = apiAction({
  types: fetchFilingStatesTypes,
  apiAction: api.fetchFilingStates,
});
